import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { OneFormState } from 'src/types';
import { MultipleCTASelection } from '.';
import { periodoContactoOptions } from 'src/feature-app/InputsValues';


export function PeriodoContacto() {
  const { errors } = useFormContext();
  const [errorContacto, setErrorPeriodoContacto] = useState(false);
  const [periodoContacto, setContacto] = useState(null);
  const { fields } = useSelector((state: OneFormState) => state.formData);
  const { error } = useOneFormContext();

  useEffect(() => {
    if (fields.periodoContacto) {
      setContacto(fields.periodoContacto);
    }
  }, []);

  useEffect(() => {
    if (error) {
      !periodoContacto ? setErrorPeriodoContacto(true) : setErrorPeriodoContacto(false);
    }
  }, [error]);

  useEffect(() => {
    if (errors.periodoContacto) {
      setErrorPeriodoContacto(true);
    } else {
      setErrorPeriodoContacto(false);
    }
  }, [errors]);

  return <MultipleCTASelection ctaValues={periodoContactoOptions} name="periodoContacto" nextOnClick />;
}
